/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQueryString = exports.filter = exports.http = exports.copy = exports.tool = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _style2 = require('antd/lib/message/style');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _config = require('./config');

var config = _interopRequireWildcard(_config);

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _es6Promise = require('es6-promise');

var _es6Promise2 = _interopRequireDefault(_es6Promise);

var _reactRouter = require('react-router');

var _premissionAuth = require('./premissionAuth');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var poli = _es6Promise2.default.polyfill();
var target = config.target;

var tool = {};
var copy = {};
var filter = {};

function formatNumber(n) {
  n = n.toString(); // eslint-disable-line
  return n[1] ? n : '0' + n;
}

/*业务系统对接*/
function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURI(r[2]);
  }
}

tool.paramType = function (data) {
  var paramArr = [];
  var paramStr = '';
  for (var attr in data) {
    paramArr.push(attr + '=' + data[attr]);
  }
  paramStr = paramArr.join('&');
  return paramStr;
};

// tool.formatTime = (number, format) => {
//   var formateArr = ['Y', 'M', 'D', 'h', 'm', 's']
//   var returnArr = []

//   var date = new Date(number)
//   returnArr.push(date.getFullYear())
//   returnArr.push(formatNumber(date.getMonth() + 1))
//   returnArr.push(formatNumber(date.getDate()))

//   returnArr.push(formatNumber(date.getHours()))
//   returnArr.push(formatNumber(date.getMinutes()))
//   returnArr.push(formatNumber(date.getSeconds()))

//   for (var i in returnArr) {
//     format = format.replace(formateArr[i], returnArr[i])
//   }
//   return format
// }

// // 数据转化
// function formatNumber(n) {
//   n = n.toString()
//   return n[1] ? n : '0' + n
// }
tool.formatTime = function (date) {
  var splitFlag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';

  if (!date) {
    return '--';
  }

  date = new Date(date);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();

  var hour = date.getHours();
  var minute = date.getMinutes();
  var second = date.getSeconds();

  return [year, month, day].map(formatNumber).join(splitFlag) + ' ' + [hour, minute, second].map(formatNumber).join(':');
};

copy.handle = function (text) {
  var node = document.createElement('input');
  node.setAttribute('value', text);
  var menu = document.querySelector('#app');
  menu.appendChild(node);
  node.select();
  document.execCommand('copy');
  var del = menu.removeChild(node);
  del = null;
  _message2.default.success('复制注册码成功！');
};

filter.networkType = function (val) {
  var tmp = {
    '1': '移动蜂窝网络',
    '2': 'WIFI',
    '3': '通过网关联网'
  };
  var str = val ? tmp[val] : '--';
  return str;
};

filter.accessType = function (val) {
  var tmp = {
    '1': 'MQTT',
    '2': 'HTTP',
    '3': '其他'
  };
  var str = val ? tmp[val] : '--';
  return str;
};

filter.operatingSystem = function (val) {
  var tmp = {
    '1': 'LINUX',
    '2': '其他'
  };
  var str = val ? tmp[val] : '--';
  return str;
};

filter.lineStatus = function (val) {
  var tmp = {
    '0': '离线',
    '1': '在线'

  };

  return tmp[val] ? tmp[val] : '--';
};

filter.activeStatus = function (val) {
  var tmp = {
    '0': '未绑定',
    '1': '已绑定'

  };

  return tmp[val] ? tmp[val] : '--';
};
filter.activeStatusE10 = function (val) {
  var tmp = {
    '0': '未绑定',
    '1': '已绑定'

  };

  return tmp[val] ? tmp[val] : '--';
};
filter.bluetoothStatus = function (val) {
  var tmp = {
    '0': '不可用',
    '1': '可用'

  };

  return tmp[val] ? tmp[val] : '--';
};

filter.deviceNetworkChannel = function (val) {
  var tmp = {
    '0': '未知类型',
    '1': '阿里云公有网络',
    '2': '阿里云专有网络'
  };

  return tmp[val] ? tmp[val] : '--';
};

filter.deviceNetworkType = function (val) {
  var tmp = {
    '0': '未知网络',
    '1': '2G网络',
    '2': '3G网络',
    '3': '4G网络',
    '4': '5G网络',
    '5': 'NB-IoT网络',
    '6': 'RS485与路由组网',
    '7': '蓝牙与路由组网',
    '8': '以太网'
  };

  return tmp[val] ? tmp[val] : '--';
};

filter.accessDeviceType = function (val) {
  var _tmp;

  var tmp = (_tmp = {
    '301': 'X8',
    '302': 'X5',
    '303': 'X9',
    '304': 'X10',
    '305': 'A6',
    '306': 'SINEXCEL',
    '307': 'R6',
    '308': 'R8',
    '309': 'X6P',
    '311': 'X6L',
    '312': 'R9',
    '313': 'A10',
    '314': 'D10',
    '102': 'M6',
    '110': 'A6',
    '111': 'A+',
    '112': 'A5',
    '113': 'A7',
    '114': 'A6C',
    '115': 'A7C',
    '116': 'M7',
    '333': 'E8D',
    '118': 'A9',
    '117': 'A8',
    '332': 'E9N',
    '121': 'T2',
    '330': 'E10',
    '334': 'E10C'
  }, (0, _defineProperty3.default)(_tmp, '332', 'E9D'), (0, _defineProperty3.default)(_tmp, '122', 'S2'), (0, _defineProperty3.default)(_tmp, '331', 'E9'), (0, _defineProperty3.default)(_tmp, '332', 'E9C'), (0, _defineProperty3.default)(_tmp, '335', 'E9F'), (0, _defineProperty3.default)(_tmp, '126', 'A9S'), _tmp);

  return tmp[val] ? tmp[val] : '--';
};

filter.SocketType = function (val) {
  if (val === null) {
    return '--';
  }
  var tmp = {
    '3000': 'NORMAL_86',
    '3010': 'X6',
    '3011': 'X6P',
    '3020': 'S6',
    '3021': 'S6L'
  };

  return tmp[val] ? tmp[val] : '--';
};

filter.SubDeviceBindStatus = function (val) {
  var tmp = {
    '0': '未绑定',
    '1': '绑定中',
    '2': '已绑定'
  };

  return tmp[val] ? tmp[val] : '--';
};

filter.lockStatus = function (val) {
  var tmp = {
    '0': '开',
    '1': '关',
    '2': '不可信',
    '3': '预留'
  };

  return tmp[val] ? tmp[val] : '--';
};

filter.batteryStatus = function (val) {
  var tmp = {
    '0': '无',
    '1': '有',
    '2': '不可信',
    '3': '预留'
  };

  return tmp[val] ? tmp[val] : '--';
};

filter.bookingStatus = function (val) {
  var tmp = {
    '0': '开',
    '1': '关',
    '2': '不可信',
    '3': '预留'
  };

  return tmp[val] ? tmp[val] : '--';
};

filter.chargerStatus = function (val) {
  var tmp = {
    '0': '离线',
    '1': '空闲',
    '2': '充电',
    '3': '充满',
    '4': '故障',
    '5': '维护'
  };

  return tmp[val] ? tmp[val] : '--';
};

filter.faultInfo = function (val) {
  var tmp = {
    '0': '通讯故障',
    '1': '电表故障',
    '2': 'LCD故障',
    '3': '过温故障',
    '4': '交流输入欠压',
    '5': '交流输入过压',
    '6': '低温故障',
    '7': '绝缘故障',
    '8': '充电机故障',
    '9': '输出过压',
    '10': '输出过流',
    '11': '烟雾告警',
    '12': '水位告警',
    '13': '交流输入过流',
    '14': '短路故障',
    '15': '开路故障',
    '16': '电压输出偏低',
    '17': '电流输出偏低',
    '18': '输出电压波动',
    '19': '输出电流波动'
  };

  return tmp[val] ? tmp[val] : '--';
};
filter.faultInfoStatus = function (val) {
  var tmp = {
    '0': '正常',
    '1': '异常'
  };

  return tmp[val] ? tmp[val] : '--';
};

filter.ProductUpgradeStatus = function (val) {
  var tmp = {
    '1': '待升级',
    '2': '升级中',
    '3': '升级完成',
    '4': '升级已取消'
  };

  return tmp[val] ? tmp[val] : '--';
};

filter.socStatus = function (val) {
  if (val === null) {
    return '--';
  }
  var v = void 0;
  if (val == 0xFE) {
    v = 1;
  } else if (val == 0xFF) {
    v = 2;
  } else if (val >= 0 && val <= 100) {
    v = 3;
  }
  var tmp = {
    '1': '无效',
    '2': '异常',
    '3': val + "%"
  };

  return tmp[v] ? tmp[v] : '--';
};

filter.currentMileage = function (val) {
  var v = void 0;
  if (val == 0xFFFFFFFF) {
    v = 1;
  } else if (val == 0xFFFFFFFE) {
    v = 2;
  } else if (val >= 0.0 && val <= 9999999) {
    v = 3;
  }
  var tmp = {
    '1': '无效',
    '2': '异常',
    '3': val / 10 + "km"
  };

  return tmp[v] ? tmp[v] : '--';
};

filter.vehichleStatus = function (val) {
  var tmp = {
    '1': '启动状态',
    '2': '熄火状态',
    '3': '其他状态',
    '0xFE': '异常',
    '0xFF': '无效'
  };

  return tmp[val] ? tmp[val] : '--';
};

var http = function http(url, data) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'POST';
  var isformdata = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var token = localStorage.getItem('token');
  var cToken = (0, _premissionAuth.getToken)();
  var options = {
    headers: {
      'Content-Type': !isformdata ? 'application/json' : 'application/x-www-form-urlencoded; charset=UTF-8',
      'Token': token ? token : cToken
    },
    method: method
  };
  options = data ? (0, _assign2.default)(options, { body: !isformdata ? (0, _stringify2.default)(data) : data }) : options;
  return new _promise2.default(function (resolve, reject) {
    (0, _isomorphicFetch2.default)(target + url, options).then(function (res) {
      if (res.ok) {
        if (url == '/api/baseBatteryInfo/getBatteryHardwareList' || url == '/api/device/getDeviceSimpleInfoList') {
          // debugger
          res.text().then(function (res) {
            var json = eval("(" + res + ")");
            if (json.status == 1) {
              resolve(json.data);
            } else if (json.status == 0) {
              if (json.message) {
                resolve(false);
                _message2.default.error(json.message);
              } else {
                resolve(false);
                _message2.default.error('后台返回数据为空');
              }
            }
          });
          return;
        }
        res.json().then(function (json) {
          console.log('%c \u63A5\u53E3\u6253\u5370\u4FE1\u606FS', 'background: #008000; color: #fff');
          console.log('%s 接口地址', url);
          console.log('%O 接口返回', json);
          console.log('%O 请求参数', options);
          console.log('%c \u63A5\u53E3\u6253\u5370\u4FE1\u606FE', 'background: #008000; color: #fff');
          if (json.status == 1) {
            resolve(json.data);
          } else if (json.status == 0) {
            if (json.message) {
              resolve(false);
              _message2.default.error(json.message);
            } else {
              resolve(false);
              _message2.default.error('后台返回数据为空');
            }
            if (json.errcode === 401 || json.errcode === 4012) {
              (0, _message2.default)({
                message: '登录信息失效',
                type: 'error',
                duration: 2 * 1000
              });
              setTimeout(function () {
                removeToken();
                window.location.href = process.env.CUS_NODE_ENV === 'test' ? 'https://test-device.mamobility.com/#/login' : '';
                window.location.reload();
              }, 2000);
            }
            if (json.message == "请先登录") {
              window.localStorage.removeItem('userName');
              window.localStorage.removeItem('token');
              _message2.default.error('\u767B\u5F55\u5DF2\u5931\u6548\u8BF7\u91CD\u65B0\u767B\u5F55');
              setTimeout(function () {
                // browserHistory.push('/login')
                _reactRouter.hashHistory.push('/login');
              }, 500);
            } else if (json.message == 'token认证失败,该token或未具备该应用权限!') {
              window.localStorage.removeItem('userName');
              window.localStorage.removeItem('token');
              _message2.default.error('token\u8BA4\u8BC1\u5931\u8D25,\u8BE5token\u6216\u672A\u5177\u5907\u8BE5\u5E94\u7528\u6743\u9650!');
              setTimeout(function () {
                // browserHistory.push('/login')
                _reactRouter.hashHistory.push('/login');
              }, 500);
            }
          } else {
            reject(json);
          }
        });
      } else {
        res.json().then(function (json) {
          reject(json);
          _message2.default.error('接口问题', json.errmsg);
        });
      }
    }).catch(function (res) {
      console.log('接口问题：', res);
      _message2.default.error('\u63A5\u53E3\u95EE\u9898');
      // browserHistory.push('/login')
      window.localStorage.removeItem('userName');
      window.localStorage.removeItem('token');
      _reactRouter.hashHistory.push('/#/login');
      reject(res || '');
    });
  });
};

exports.tool = tool;
exports.copy = copy;
exports.http = http;
exports.filter = filter;
exports.getQueryString = getQueryString;

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "tool.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/utils/tool.jsx
// module id = 406
// module chunks = 0